import { Add } from "@mui/icons-material";
import PaperButton from "components/buttons/PaperButton";
import SearchComponent from "components/SearchComponent";
import { ERR_NETWORK } from "constants/messages";
import { modifyArray, removeItemArray } from "lib/arrayObject";
import { serverGet, serverPost } from "lib/serverRequest";
import { getUsers, updateUser } from "models/usersModel";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useRef, useState } from "react";
import { closeModal, openLoading, openModal } from "store/reducers/tools";
import StaffForm from "./forms/StaffForm";
import StaffTable from "./forms/StaffTable";

export const statusOption = [
  { id: "1", label: "active" },
  { id: "0", label: "disabled" },
];

export const roleOption = [
  { id: "1", label: "packer" },
  { id: "2", label: "admin" },
];

export default function StaffComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const addFormRef = useRef();
  // const editFormRef = useRef();
  const [data, setData] = useState([]);
  const [searchWord, setSearchWord] = useState("");

  const searchData = useMemo(() => {
    let filteredData = data;
    if (searchWord) {
      filteredData = filteredData.filter((row) => {
        const newStr = { ...row, address: row?.address?.label ?? "" };
        let searchWords = searchWord.split(" "),
          s = 0,
          strObject = Object.values(newStr).join("");
        searchWords.forEach((t) => {
          if (strObject.toLowerCase().search(t.toLowerCase()) > 0) s++;
        });
        if (s > 0) return true;
        else return false;
      });
    }
    return filteredData;
  }, [data, searchWord]);

  const handleSearchWord = (e) => {
    setSearchWord(e.target.value.trim().replace(/[^A-Za-z0-9@. ]/g, ""));
  };

  const loadData = () => {
    openLoading(true);
    getUsers({
      data: { role: ["1", "2"] },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setData(res?.data);
      },
    });
  };

  const handleAdd = () => {
    openModal({
      title: "Add New Staff",
      content: <StaffForm ref={addFormRef} />,
      onSave: () => {
        const submitData = addFormRef.current?.prepare();
        if (submitData) {
          delete submitData.confirm_password;
          openLoading(true);
          serverPost({
            url: "register",
            data: {
              ...submitData,
              verify: true,
            },
            onFinish: (res, err) => {
              openLoading(false);
              if (res === false) {
                if (!res && err?.message) {
                  enqueueSnackbar(err?.message, { variant: "warning" });
                } else {
                  enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
                }
                return;
              }
              enqueueSnackbar("Successfully Saved in", {
                variant: "success",
              });
              setData((s = []) => [res?.user ?? {}, ...(s ?? [])]);
              closeModal();
            },
          });
        }
      },
    });
  };

  const handleDelete = (user) => {
    openLoading(true);
    serverGet({
      url: `user/staff/delete/${user?.id}`,
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        enqueueSnackbar("Successfully deleted in", {
          variant: "success",
        });
        setData((s = []) => {
          const index = s?.findIndex((item) => user?.id === item?.id);
          return removeItemArray(s, index);
        });
      },
    });
  };

  const handleEdit = (user) => {
    openModal({
      title: "Edit Staff",
      content: <StaffForm ref={addFormRef} data={user} actionType="edit" />,
      onSave: () => {
        const submitData = addFormRef.current?.prepare();
        if (submitData) {
          openLoading(true);
          updateUser({
            data: submitData,
            onFinish: (res, err) => {
              openLoading(false);
              if (res === false) {
                if (!res && err?.message) {
                  enqueueSnackbar(err?.message, { variant: "warning" });
                } else {
                  enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
                }
                return;
              }
              enqueueSnackbar("Successfully Updated in", {
                variant: "success",
              });
              setData((s = []) => {
                const index = s?.findIndex((user) => user?.id === res?.id);
                return modifyArray(s, index, res);
              });
              closeModal();
            },
          });
        }
      },
    });
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="flex justify-between mb-4">
        <SearchComponent
          onKeyDown={(e) => handleSearchWord(e)}
          onBlur={handleSearchWord}
          searchWord={searchWord}
          placeholder="Search Staff Users"
        />
        <PaperButton
          onClick={handleAdd}
          icon={<Add className="text-light-gray" />}
        >
          Add New Staff
        </PaperButton>
      </div>
      <StaffTable
        data={searchData}
        onChange={setData}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
}
